@if (environmentService.blockAccessForServiceWindow) {
  <div class="align-center custom-column h-vh-100">
    <h1 class="f-18">
      {{ environmentService.serviceOutageMessage }}
    </h1>
  </div>
} @else if (this.environmentService.isCodebook) {
  <router-outlet />
} @else {
  @if (deviceSize$ | async; as deviceSize) {
    @if ((authenticationState$ | async) === AuthenticationState.AUTHENTICATED) {
      <app-nav-bar />
      <div
        class="w-100 p-0 main-wrapper"
        [ngClass]="{ mobile: deviceSize.isMobile, 'service-outage-banner': environmentService.upcomingServiceWindow }"
      >
        <div class="left-section" tabindex="0" aria-expanded="false">
          <app-sidebar class="sidebar" />
        </div>

        <div class="right-section pb-medium" [ngClass]="{ 'ps-medium': !deviceSize.isMobile }">
          @if (environmentService.isPx && environmentService.isViewingTestCustomer()) {
            <div
              class="bg-error-50 fc-error-900 align-center f-14 fw-heavy p-medium my-medium border-all border-color-error-900 box w-100"
            >
              You are viewing a Test Customer. Do not rely on any data shown here for business decisions.
            </div>
          }
          <router-outlet />
        </div>
      </div>

      @if (showHelpBarTrigger$ | async) {
        <div
          class="genie fc-white align-center f-28 fw-heavy"
          [ngClass]="{
            'athena-mobile-spacing': deviceSize.isMobile,
            'athena-web-spacing': !deviceSize.isMobile,
          }"
          (click)="toggleHelpBar()"
        >
          <img src="assets/logo/owl.gif" width="80" height="80" alt="Help Icon" />
        </div>
      }
    } @else {
      <div class="w-100 p-0" [ngClass]="{ mobile: deviceSize.isMobile, 'h-100': airtelRedirectService.showError() }">
        <router-outlet />
      </div>
    }

    @if (this.environmentService.isPrudentPlus || (environmentService.isPx && featureFlagsService.pxAiDataQuery)) {
      <div class="help-bar" [ngClass]="{ hidden: !showHelpBar, expanded: showHelpBar, mobile: deviceSize.isMobile }">
        <ng-template #viewContainerRef class="w-100" />
      </div>
      @if (athenaMessage$ | async; as message) {
        <div
          class="help-bar-message f-14 fw-heavy box"
          [ngClass]="{
            hidden: showHelpBar || !message.message,
            'p-medium': !(showHelpBar || !message.message),
          }"
        >
          {{ message.message }}
        </div>
      }
    }

    @if (showHelpBar) {
      <div class="overlay" (click)="showHelpBar = false"></div>
    }
  }
  <span hidden id="application-version">{{ environmentService.version | json }}</span>
}
